import React from 'react';
import { Button, Dropdown, Tag } from 'antd';
import type { MenuProps } from 'antd';
import { MoreOutlined, EditOutlined, LinkOutlined, DeleteOutlined, PictureOutlined } from '@ant-design/icons';
import { MobileWatch, STATUS_COLORS, STATUS_LABELS, formatPrice } from './productStatus';
import { Card, Thumb, Info, Brand, Model, PriceRow, Meta, MenuButton } from './ProductCard.style';

const API_URL = process.env.REACT_APP_API_URL || '';

interface ProductCardProps {
  watch: MobileWatch;
  onOpen: (watch: MobileWatch) => void;
  onEdit: (watch: MobileWatch) => void;
  onCopyShortLink: (watch: MobileWatch) => void;
  onDelete: (watch: MobileWatch) => void;
}

const ProductCard: React.FC<ProductCardProps> = ({ watch, onOpen, onEdit, onCopyShortLink, onDelete }) => {
  const image = watch.images?.[0];
  const tapSize = { paddingTop: 11, paddingBottom: 11 };
  const items: MenuProps['items'] = [
    { key: 'edit', icon: <EditOutlined />, label: 'Bearbeiten', style: tapSize },
    ...(watch.shortCode ? [{ key: 'copy', icon: <LinkOutlined />, label: 'Short-Link kopieren', style: tapSize }] : []),
    { type: 'divider' as const },
    { key: 'delete', icon: <DeleteOutlined />, label: 'Löschen', danger: true, style: tapSize },
  ];
  const onMenuClick: MenuProps['onClick'] = ({ key, domEvent }) => {
    domEvent.stopPropagation();
    if (key === 'edit') onEdit(watch);
    if (key === 'copy') onCopyShortLink(watch);
    if (key === 'delete') onDelete(watch);
  };

  return (
    <Card onClick={() => onOpen(watch)} data-testid={`mobile-watch-card-${watch.id}`}>
      <Thumb>
        {image ? <img src={`${API_URL}${image.thumbnailUrl || image.originalUrl}`} alt={`${watch.brand} ${watch.model}`} loading="lazy" /> : <PictureOutlined />}
      </Thumb>
      <Info>
        <Brand>{watch.brand}</Brand>
        <Model>{watch.model}</Model>
        <PriceRow>
          {formatPrice(watch.priceCents)}
          <Tag color={STATUS_COLORS[watch.status]}>{STATUS_LABELS[watch.status] || watch.status}</Tag>
        </PriceRow>
        <Meta>SKU {watch.sku || '—'} | Ref. {watch.referenceNumber || '—'}</Meta>
      </Info>
      <MenuButton onClick={(e) => e.stopPropagation()}>
        <Dropdown menu={{ items, onClick: onMenuClick }} trigger={['click']} placement="bottomRight">
          <Button type="text" icon={<MoreOutlined style={{ fontSize: 20 }} />} aria-label="Aktionen" data-testid={`mobile-watch-menu-${watch.id}`} />
        </Dropdown>
      </MenuButton>
    </Card>
  );
};

export default ProductCard;
